/**
 * Symbolic name referring to the act of registering for an event.
 */
export const EVENT_REGISTRATION = 'EVENT_REGISTRATION';
